<template>
    <v-container fluid>

        <div class="centered-content mt-sm-8 mt-md-12">


            <v-alert border="left" colored-border elevation="2"
                     transition="slide-y-transition"
                     type="success"
                     v-model="isSuccess">
                <div>Votre mot de passe a bien été modifié</div>
                <v-row align="center" class="mt-2" no-gutters>
                    <v-spacer></v-spacer>
                    <v-col class="shrink">
                        <v-btn @click="$router.push('login')" text>Se connecter</v-btn>
                    </v-col>
                </v-row>
            </v-alert>
            <v-alert border="left" colored-border elevation="2"
                     transition="slide-y-transition"
                     type="warning"
                     v-model="isTokenExpired">
                <div>La période de renouvellement de mot de passe a expiré.</div>
                <v-row align="center" class="mt-2" no-gutters>
                    <v-spacer></v-spacer>
                    <v-col class="shrink">
                        <v-btn @click="sendNewCode" text>Renvoyer un email</v-btn>
                    </v-col>
                </v-row>
            </v-alert>
            <v-alert border="left" elevation="2"
                     transition="slide-y-transition"
                     type="error"
                     v-model="isUnknownError">
                <div>Une erreur est survenue. Si le problème persiste, contactez le <a
                        href="https://support.yodaforex.com">support Yodaforex</a></div>
                <v-row align="center" class="mt-2" no-gutters>
                    <v-spacer></v-spacer>
                    <v-col class="shrink">
                        <v-btn @click="sendNewCode" text>Renvoyer un email</v-btn>
                    </v-col>
                </v-row>
            </v-alert>

            <v-card :disabled="isSuccess || isTokenExpired" :loading="submitting">
                <v-card-title class="word-wrap">Modifier votre mot de passe</v-card-title>
                <v-container class="pa-sm-8">
                    <v-form @submit.prevent="submit"
                            ref="loginForm" v-model="isFormValid">
                        <v-row>
                            <v-col>
                                <v-text-field :disabled="true"
                                              :loading="loading" class="thin-outlined"
                                              hide-details label="Email" outlined
                                              v-model="displayedEmail"/>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field :append-icon="hidePassword ? 'visibility' : 'visibility_off'"
                                              :color="passwordStrengthColor" :disabled="submitting"
                                              :type="hidePassword ? 'password' : 'text'"
                                              @click:append="() => (hidePassword = !hidePassword)" class="thin-outlined"
                                              hide-details label="Nouveau mot de passe" outlined v-model="password"/>
                                <password-strength :password="password" @color="passwordStrengthColor = $event"
                                                   class="mt-2"
                                                   v-model="isPasswordSafe"/>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-btn :disabled="!isPasswordSafe" :loading="submitting" block color="success"
                                       type="submit">
                                    Envoyer
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card>
        </div>
    </v-container>
</template>

<script>

	import PasswordStrength from "../../components/PasswordStrength";

	export default {
		name: "ForgotPasswordView",
		components: {PasswordStrength},
		data() {
			return {
				hidePassword: true,
				isTokenExpired: false,
				isUnknownError: false,
				isSuccess: false,
				token: "",
				expirationDate: null,
				isFormValid: false,
				loading: false,
				submitting: false,
				password: "",
				isPasswordSafe: false,
				passwordStrengthColor: "primary",
				displayedEmail: ""
			}
		},
		mounted() {
			this.fetchTokenPayload();
		},
		methods: {
			fetchTokenPayload() {
				let url = new URL(window.location.origin + window.location.hash.substring(1));
				this.token = url.searchParams.get("token");
				if (!this.token) {
					this.isUnknownError = true;
				} else {
					this.loading = true;
					this.$http.post(this.$config.apiUrl + "/v2/passwords/forgot/renew", {resetCode: this.token})
						.then(r => {
							this.displayedEmail = r.data.user.email;
							this.token = r.data.resetCode;
							this.expirationDate = r.data.expirationDate;
						})
						.catch(e => {
							if (e.response && e.response.status === 400) {
								this.isTokenExpired = true;
							} else this.isUnknownError = true;
						})
						.finally(() => this.loading = false);
				}

			},
			submit() {
				if (this.isPasswordSafe && !this.submitting) {
					this.submitting = true;
					this.$http.post(this.$config.apiUrl + "/v2/passwords/forgot/changerequest", {
						resetCode: this.token,
						password: this.password
					})
						.then(r => {
							this.isSuccess = true;
						})
						.catch(e => {
							if (e.response && e.response.status === 400) {
								this.isTokenExpired = true;
							} else this.isUnknownError = true;
						})
						.finally(() => this.submitting = false);
				}
			},
			sendNewCode() {
				alert("nope");
			}
		}
	}
</script>

<style scoped>
    .word-wrap {
        word-break: normal;
    }

    .centered-content {
        max-width: 600px;
        margin-left: auto;
        margin-right: auto;
    }
</style>
